<app-page-heading [key]="'truck-journeys.load-assignment.header'">
    <div class="page-heading-left-content">
        <button type="button" class="btn btn-primary btn-outline btn-lg pull-left"
                (click)="exitLoadAssignmentPage()">
            <span class="fa fa-arrow-left"> </span>
        </button>
    </div>
    <app-carrier-sync class="page-heading-right-content" [carrierId]="carrierId"></app-carrier-sync>
</app-page-heading>

<div [ngClass]="{ 'hidden': showScreen !== SubScreen.TRUCK_JOURNEYS_SELECT }" class="truckJourneyLoadAssignmentPage">
    <div class="truckJourneyLoadAssignmentPage-container">
        <app-data-filters #dataFilters
                          [opened]="true"
                          [fullWidth]="true"
                          [disableSearch]="!this.isValidSearch || (this.isLoading | async)"
                          [titleKey]="'truck-journeys.load-assignment.filter.search'">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-date [labelKey]="'truck-journeys.load-assignment.filter.planned-departure-date'"
                                      [(model)]="filters.plannedDepartureFrom"
                                      (modelChange)="checkSearchValidity()"
                                      [minDate]="yesterday"
                                      [required]="true">
                </app-data-filter-date>
                <app-data-filter-input [labelKey]="'truck-journeys.load-assignment.filter.vehicle'"
                                       [(model)]="filters.vehicle"
                                       (modelChange)="checkSearchValidity()"
                                       [required]="true"
                                       [minLength]="1">
                </app-data-filter-input>
            </app-data-filter-group>
        </app-data-filters>
        <div class="flex-row truckJourneyLoadAssignmentPage-radioContainer">
            <div class="radio">
                <label>
                    <input type="radio" [name]="'truck-journey-new'" [value]="-1"
                           [(ngModel)]="selectedTruckJourneyIndex">
                    <i class="fa radio-icon"></i>
                </label>
            </div>
            <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.load-assignment.assign-load-to-new-truckjourney',
            params: { vehicle: filters.vehicle, date: filters.plannedDepartureFrom?.format('DD/MM/YYYY') }}]"></span>
        </div>
        <div *ngIf="!searchLaunched" class="noLoads">
            <i class="fas fa-search"></i>
            <span [i18n]="'truck-journeys.load-assignment.no-search-launched'"></span>
        </div>
        <div *ngIf="(!truckJourneys || truckJourneys.length === 0) && searchLaunched" class="noLoads">
            <i class="fas fa-route"></i>
            <span [i18n]="'truck-journeys.load-assignment.no-truck-journeys-with-these-criterias'"></span>
        </div>
        <div class="truckJourneyLoadAssignmentPage-radioItem-container">
            <div *ngFor="let truckJourney of truckJourneys; let i=index"
                 class="flex-row truckJourneyLoadAssignmentPage-radioItem">
                <div class="radio">
                    <label>
                        <input type="radio" [name]="'truck-journey-'+truckJourney.id" [value]="i"
                               [(ngModel)]="selectedTruckJourneyIndex">
                        <i class="fa radio-icon"></i>
                    </label>
                </div>
                <div class="truckJourneyLoadAssignmentPage-radioItem-content"
                     [class._selected]="selectedTruckJourneyIndex === i">
                    <app-truck-journey-info [truckJourney]="truckJourney" [readOnly]="true">
                    </app-truck-journey-info>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-buttons">
        <button (click)="changeLoadSelection()" class="btn">
            <span [i18n]="'truck-journeys.load-assignment.button.change-loads-selection'"></span>
        </button>
        <button (click)="assignLoads()" class="btn btn-primary">
            <span [i18n]="'truck-journeys.load-assignment.button.assign'"></span>
        </button>
    </div>
</div>

<div *ngIf="showScreen===SubScreen.LOADS_SELECT" class="truckJourneyLoadAssignmentPage">
    <app-truck-journey-load-assignment
        id="TruckJourneyLoadAssignment"
        [(selectedLoads)]="loadAssignments">
    </app-truck-journey-load-assignment>
    <div class="bottom-buttons">
        <button type="button" (click)="exitLoadAssignmentPage()" class="btn">
            <span [i18n]="'truck-journeys.load-assignment.button.cancel'"></span>
        </button>
        <button type="button" (click)="goToTruckJourneySelection()" class="btn btn-primary">
            <span [i18n]="'truck-journeys.load-assignment.button.assign-to-a-truck-journey'"></span>
        </button>
    </div>
</div>
